import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ToastrService } from "ngx-toastr";

import { BaseService } from "./base.service";
import { ITimeline } from "../interfaces/itimeline";
import { ApplicationSettingsService } from "./applicationsettings.service";
import { AuthService } from "./auth.service";

@Injectable()
export class EventService extends BaseService {
    constructor(http: HttpClient, private applicationSettings: ApplicationSettingsService, authService: AuthService, toastsManager: ToastrService) {
        super(http, authService, toastsManager);
    }

    getEvents(): Observable<ITimeline> {
        return super.get(`${this.applicationSettings.apiUrl}Events`);
    }
}